module.exports = __webpack_public_path__ + "static/media/project10.adc5aeeb.jpg";